export default "__VITE_ASSET__DmKIzOa___"